if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener("click", (event)=>this.hide(event))
        this.slides = this.querySelectorAll(".swiper-slide")
  
        this.pdpZoomSlider = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
  
      hide(event) {
        if(event.target.closest('.product-media-modal__toggle')){
          super.hide();
        }
      }
  
      show(opener) {
        this.showActiveMedia(opener);
        setTimeout(()=>{
          super.show(opener);
          console.log("VAMO ALLA MANOLO")
        }, 200)
      }
  
      showActiveMedia(opener) {
        var index = 0
        var position = -1
        //remove unnecesary slides
        this.querySelector(".swiper-wrapper").innerHTML = ""
        const currentVariant = document.querySelector(`#${this.dataset.formId}`).querySelector("input[name='id']").value
        this.slides.forEach(slide=>{
          const slideIds = slide.dataset.variantId.replace("[", "").replace("]", "").split(",")
          if(slideIds.includes(currentVariant) || slideIds == "ALL"){
            position++
            this.querySelector(".swiper-wrapper").appendChild(slide)
            console.log(slide.dataset.slideIndex, opener.dataset.slideIndex, slide)
            if(parseInt(slide.dataset.slideIndex)  == parseInt(opener.dataset.slideIndex)){
              index = position
            }
          }
        })
        this.pdpZoomSlider.update()
        this.pdpZoomSlider.slideTo(index)
      }
    });
  }